import { Button, Modal, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdLibraryAdd } from "react-icons/md";
import styled from "styled-components";
import { makeToasterErrorHandler } from "../../common/http/makeToasterErrorHandler";
import { usePageToast } from "../../hooks/usePageToast";
import api from "../../services/api";
import {
  ActionsContainer,
  ModalBody,
  SearchContainer,
  StyledTable,
  TableContainer
} from "../style/assign-device-modal.styled";
import PageToaster from "../toaster/PageToaster";

interface AssignServiceModalProps {
  open: boolean;
  onClose: () => void;
  onServiceAssigned: () => void;
  deviceId?: number;
  workOrderId: string;
}

const TableHeader = styled.th``;

const AssignServiceModal: React.FC<AssignServiceModalProps> = ({
  open,
  onClose,
  onServiceAssigned,
  deviceId,
  workOrderId
}) => {
  const [search, setSearch] = useState("");
  const [results, setResults] = useState<any[]>([]);

  const [deviceIdState, setDeviceIdState] = useState(0);

  const containerId = "toaster-assign-service-modal";
  const { autoSuccess, autoError, autoInfo, autoWarn } = usePageToast(
    containerId,
    true
  );

  const handleHttpError = makeToasterErrorHandler(autoError);

  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        const { data } = await api.get("/service-performed", {
          params: {
            page: 1,
            limit: 20,
            ...(search ? { service_performed_name: search } : {})
          }
        });

        setDeviceIdState(deviceId || 0); // Atualiza o deviceIdState com o valor recebido
        // VERIFICA se data.items existe
        setResults(data.items ?? []);
      } catch (err) {
        console.error(err);
        setResults([]);
      }
    })();
  }, [open, search]);

  const clear = () => {
    setSearch("");
    setResults([]);
    setDeviceIdState(0);
  };

  const handleAssign = async (serviceId: number) => {
    try {
      await api.post(
        `/work-order/${workOrderId}/device/${deviceId}/service/${serviceId}`
      );
      autoSuccess("Serviço associado com sucesso!");
      setResults((prev) =>
        prev.filter((s) => s.service_performed_id !== serviceId)
      );
      onServiceAssigned();
      clear();
      onClose();
    } catch (e: any) {
      handleHttpError(e);
      console.error("Erro ao associar serviço:", e);
    }
  };

  return (
    <>
      <PageToaster containerId={containerId} />
      <Modal open={open} onClose={onClose}>
        <ModalBody>
          <h2>Associar Serviço</h2>

          <SearchContainer>
            <TextField
              label="Buscar por Nome"
              fullWidth
              size="small"
              margin="dense"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </SearchContainer>

          <TableContainer>
            <StyledTable>
              <thead>
                <tr>
                  <TableHeader>Nome</TableHeader>
                  <TableHeader>Descrição</TableHeader>
                  <TableHeader>Valor (R$)</TableHeader>
                  <TableHeader>Ação</TableHeader>
                </tr>
              </thead>
              <tbody>
                {results.map((service) => (
                  <tr key={service.service_performed_id}>
                    <td>{service.service_performed_name}</td>
                    <td>{service.service_performed_description}</td>
                    <td>
                      {parseFloat(service.service_performed_cost).toFixed(2)}
                    </td>
                    <td>
                      <MdLibraryAdd
                        color="#03F"
                        style={{ cursor: "pointer" }}
                        size={18}
                        onClick={() =>
                          handleAssign(service.service_performed_id)
                        }
                      />
                    </td>
                  </tr>
                ))}
                {results.length === 0 && (
                  <tr>
                    <td
                      colSpan={4}
                      style={{ textAlign: "center", padding: "16px" }}
                    >
                      Nenhum serviço encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </StyledTable>
          </TableContainer>

          <ActionsContainer>
            <Button onClick={onClose} color="secondary">
              Fechar
            </Button>
          </ActionsContainer>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AssignServiceModal;
